'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function useDidUpdateEffect(fn, inputs) {
  var didMountRef = React.useRef(false);
  React.useEffect(function () {
    if (didMountRef.current) {
      fn();
    } else {
      didMountRef.current = true;
    }
  }, inputs);
}

exports.default = useDidUpdateEffect;
//# sourceMappingURL=useDidUpdateEffect.js.map
